exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-container[data-v-72e2a71d] {\n  padding-bottom: 10px;\n}\n.filter-item[data-v-72e2a71d] {\n  margin-right: 10px;\n}\n.line-text[data-v-72e2a71d] {\n  line-height: 1.6;\n}\n.draw-time[data-v-72e2a71d] {\n  color: #909399;\n  font-size: 12px;\n}\n.join-num[data-v-72e2a71d] {\n  padding: 0 2px;\n  font-weight: bold;\n}\n.join-gap[data-v-72e2a71d] {\n  margin-left: 6px;\n}\n", ""]);

// exports
